import type { IconData } from '@stacksjs/iconify-core'

export const weatherRainbow: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M29.715 8.385h-7.62v1.52h-4.57v1.52h-3.05v1.53h-1.52v1.52h-1.53v3.05h-1.52v4.57h-1.52v7.62h-6.1v1.52h16.76v-1.52h-6.09v-7.62h1.52v-3.05h1.53v-1.52h1.52v-1.52h1.52v-1.53h3.05v-1.52h7.62v6.09h1.52V2.285h-1.52z\"/><path fill=\"currentColor\" d=\"M22.095 19.045h7.62v1.53h-7.62Zm0-18.28h7.62v1.52h-7.62Zm-1.52 19.81h1.52v1.52h-1.52Zm-1.53 1.52h1.53v7.62h-1.53Zm-1.52-19.81h4.57v1.52h-4.57Zm-4.57 1.52h4.57v1.53h-4.57Zm-3.05 1.53h3.05v1.52h-3.05Zm-1.52 1.52h1.52v1.53h-1.52Zm-1.53 1.53h1.53v1.52h-1.53Zm-1.52 1.52h1.52v3.05h-1.52Zm-1.52 3.05h1.52v4.57h-1.52Zm-1.53 4.57h1.53v4.57h-1.53Zm-1.52 4.57h1.52v7.62H.765Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default weatherRainbow
